<template>
  <DrawerLandingCity
    :imgUrl="formItem.icon_url"
    :omegaItem="omegaItem"
    :title="formItem.title"
    :areaClassError="areaClassError"
    @changeCity="getPageConf"
  />
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { post } from "../../tools/request";
import { getLocation } from "../../tools/utils";
import DrawerLandingCity from "../base/drawer-landing-city.vue";

export default {
  props: ["formItem", "omegaItem", "hasProduct", "areaClassError"],
  components: {
    DrawerLandingCity,
  },
  mounted() {
    // console.log('hasProduct', this.hasProduct)
    if (!this.hasProduct) {
      getLocation(this.getLocateCity);
    }
  },
  computed: {
    ...mapState(["_ticket", "_area"]),
  },
  methods: {
    ...mapMutations(["setState"]),
    getPageConf() {
      this.$emit("refresh");
    },
    getLocateCity(lng, lat) {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      up.set("lng", lng);
      up.set("lat", lat);

      post(process.env.LANDING_PAGE_GET_LOCATE_CITY, up)
        .then((data) => {
          this.setState({
            _area: {
              text: data.text,
              value: data.value,
            },
            _open_type: data.open_type,
          });
          this.$emit("refresh", 'city');
          Omega.trackEvent(
            "ibt_onboarding_landingpagecity_sw",
            "",
            this.omegaItem
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.com-wrapper {
  position: relative;
  height: 2.22rem;
  margin: 0 0.24rem;
  .driver-info {
    position: absolute;
    width: 100%;
    height: 3.34rem;
    top: -1.06rem;
    background: #fff;
    box-shadow: 0.06rem 0.06rem 0.3rem 0 rgba(0, 0, 0, 0.06);
    border-radius: 0.12rem;
  }
}
</style>


